<template>
    <div class="container yjAuditDetail" v-if="isVisible" style="z-index:1">
        <div class="bankAuditDialog">
            <el-row>
                <el-col :span="24">
                    <div class="bankAuditHeader">
                        <div class="bankAuditHeaderName"></div>
                        <div class="bankAuditHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="进度信息" name="zero">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row style="background-color:#fff">
                            <el-col :span="24" style="padding:20px" >
                                <el-steps :active="stepsStatus" align-center :process-status="errorflag==true ? 'error':'process'">
                                    <el-step title="用户申请" :description="loanAudit.CreateTime"></el-step>
                                    <el-step title="转贷经办" :description="loanAudit.SecondTime"></el-step>
                                    <el-step title="转贷初审" :description="loanAudit.FirstNewTime"></el-step>
                                    <el-step title="转贷复审" :description="loanAudit.ThirdTime"></el-step>
                                    <el-step title="银行初审" :description="loanAudit.FourthTime"></el-step>
                                    <el-step title="银行复审" :description="loanAudit.FiveTime"></el-step>
                                    <el-step title="银行终审" :description="loanAudit.SixTime"></el-step>
                                    <el-step title="转贷终审" :description="loanAudit.SevenTime"></el-step>
                                    <el-step title="签约完成" :description="loanAudit.EndTime"></el-step>
                                </el-steps>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div style="margin-top:20px;font-weight:bold">
                                    基本信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow"  v-if="loanAudit.PersonFlag===2">
                            <el-col :span="8">
                                <div class="viewText">企业名称：{{loanAudit.CompanyName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">营业执照号：{{loanAudit.CompanyCode}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText"><span v-if="loanAudit.PersonFlag==2">法人</span>
                                    <span v-else>姓名</span>：{{loanAudit.UserName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">身份证号：{{loanAudit.IdCard}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">联系方式：{{loanAudit.Phone}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">贷款名称：{{loanAudit.LoanName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">申请金额：{{loanAudit.Money}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">贷款银行：{{loanAudit.BankName}}</div>
                            </el-col>
                        </el-row>
                        <el-row  class="viewRow">
                            <el-col :span="8">
                                <div class="viewText"  v-if="loanAudit.State==8">状态：合同过期</div>
                                <div class="viewText"  v-if="loanAudit.State==7">状态：用户未签约</div>
                                <div class="viewText"  v-if="loanAudit.State==6">状态：已签约</div>
                                <div class="viewText"  v-if="loanAudit.State==3||loanAudit.State==5">状态：被拒绝</div>
                                <div class="viewText"  v-if="loanAudit.State==2">状态：转贷审核通过</div>
                                <div class="viewText"  v-if="loanAudit.State==4">状态：银行审核通过</div>
                                <div class="viewText"  v-if="loanAudit.State==1">状态：审核中</div>
                            </el-col>
                            <el-col :span="8"  v-if="loanAudit.State==6||loanAudit.State==4">
                                <div class="viewText" >转贷金额：{{loanAudit.FinalMoney}}万元</div>
                            </el-col>
                            <el-col :span="2"  v-if="loanAudit.Route>1">
                                <div  class="viewText">
                                     <el-button size="small" type="primary"  @click="handlePreView(loanAudit)">合同预览</el-button>
                                </div>
                            </el-col>
                             <el-col :span="2" v-if="loanAudit.ContractState==2" >
                                <div  class="viewText">
                                     <el-button size="small" type="success" @click="toUpdateContract(loanAudit)">状态更新</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div style="margin-top:20px;font-weight:bold">流程记录</div>
                            </el-col>
                        </el-row>
                        <div style="margin:20px 10px;">
                            <el-timeline>
                                <template v-for="(item,index) in flowLogs" :key="index">
                                    <el-timeline-item :timestamp="item.CreateTime" placement="top">
                                        <el-card>
                                            <p>操作人：{{item.UserName?item.UserName:"无"}}</p>
                                            <div style="height:5px;width:100px;"></div>
                                            <h4>{{item.Content}}</h4>
                                        </el-card>
                                    </el-timeline-item>
                                </template>
                            </el-timeline>
                        </div>
                    </el-scrollbar>
                </el-tab-pane>
                    <el-tab-pane label="审核信息" name="first">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-form  ref="ruleForm" style="padding:0px 8px" :model="loanAudit">
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        基本信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row v-if="loanAudit.PersonFlag===2">
                                    <el-col :span="3" >
                                        <div class="bankAuditLB">企业名称：</div>
                                    </el-col>
                                    <el-col :span="5" >
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.CompanyName"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">营业执照号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.CompanyCode"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    </el-row>
                                    <el-row>
                                    <el-col :span="3" >
                                        <div class="bankAuditLB" v-if="loanAudit.PersonFlag===2">法定代表人：</div>
                                        <div class="bankAuditLB" v-else>姓名：</div>
                                    </el-col>
                                    <el-col :span="5" >
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.UserName"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">身份证号：</div>
                                    </el-col>
                                    <el-col :span="5" >
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.IdCard"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">联系方式：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.Phone"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
                                                        <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">申请银行：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.BankName"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">申请金额（万元）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.Money"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row  v-if="loanAudit.PersonFlag==1">
                                <el-col :span="3">
                                        <div class="bankAuditLB">配偶姓名：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.POName"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">配偶电话：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.POPhone"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">配偶身份证号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.POIdCard"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row >
                                    <el-col :span="3">
                                        <div class="bankAuditLB">用户地址：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.UserAddress"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                       <el-col :span="3">
                                        <div class="bankAuditLB"  v-if="loanAudit.PersonFlag==1">经营地址：</div>
                                        <div class="bankAuditLB" v-else>公司地址：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.CompanyAddress"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                       <el-col :span="3" v-if="loanAudit.PersonFlag==1">
                                        <div class="bankAuditLB">配偶地址：</div>
                                    </el-col>
                                    <el-col :span="5" v-if="loanAudit.PersonFlag==1">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.POAddress"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    </el-row>
                            <el-row  v-if="loanAudit.ReturnReason&&loanAudit.Route==1">
                                <el-col :span="3">
                                        <div class="bankAuditLB">退回原因：</div>
                                    </el-col>
                                    <el-col :span="21">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.ReturnReason"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        贷款信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">经办银行：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="JBYH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.JBYH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                <el-col :span="3">
                                        <div class="bankAuditLB">贷款合同号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="DKHTH"> 
                                            <el-input
                                               disabled
                                                v-model="loanAudit.DKHTH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                     <el-col :span="3">
                                        <div class="bankAuditLB">续贷合同号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="XDHTH"> 
                                            <el-input
                                               disabled
                                                v-model="loanAudit.XDHTH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">经办银行联系人：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="JBYHLXR"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.JBYHLXR"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">经办银行联系人电话：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="JBYHLXRDH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.JBYHLXRDH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                           </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">经办银行固定客服电话：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.JBYHGDKFDH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">原贷款金额（万元）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="OldMoney"> 
                                            <el-input
                                            disabled
                                                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                                                v-model="loanAudit.OldMoney"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">贷款到期日期：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="LoanEndTime">  
                                              <el-input
                                             disabled
                                                v-model="loanAudit.LoanEndTime"
                                                size="small"
                                                placeholder=""> </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">续贷金额（万元）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="XDMoney"> 
                                            <el-input
                                            disabled
                                                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                                                v-model="loanAudit.XDMoney"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        企业银行账户信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">户名：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="YHHM"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.YHHM"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">开户行：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="YHKHH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.YHKHH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">账号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="YHZH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.YHZH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        银行账户信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">内部账号名称：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="NBZHHM"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.NBZHHM"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">内部账号开户行：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="NBZHKHH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.NBZHKHH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">内部账号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="NBYHZH"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.NBYHZH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                              <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷专户名称：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="ZDZHHM"> 
                                            <el-input
                                              disabled
                                                v-model="loanAudit.ZDZHHM"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷专户开户行：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="ZDZHKHH"> 
                                            <el-input
                                              disabled
                                                v-model="loanAudit.ZDZHKHH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷专户账号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="ZDZHZH"> 
                                            <el-input
                                              disabled
                                                v-model="loanAudit.ZDZHZH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                     <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷营业部行号：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="ZDYYBHH"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.ZDYYBHH"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        转贷信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                                              <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷金额（万元）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="FinalMoney"> 
                                            <el-input
                                            disabled
                                                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                                                v-model="loanAudit.FinalMoney"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>使用费率(‰)：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="SYFL"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.SYFL"
                                                 oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>综合服务费（元）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="ZDServeMoney"> 
                                            <el-input
                                            disabled
                                                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                                                v-model="loanAudit.ZDServeMoney"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <!-- <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>逾期费率(%)：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="YQFL"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.YQFL"
                                                 oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                                                        <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>违约费率(%)：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="WYFL"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.WYFL"
                                                 oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col> -->
                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>申请借款期限：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="SQJKQX">  
                                                <el-date-picker
                                                disabled
                                                    v-model="loanAudit.SQJKQX"
                                                    style="width:100%"
                                                    size="small"
                                                    type="daterange"
                                                    range-separator="-"
                                                   start-placeholder="开始日期"
                                                   end-placeholder="结束日期"
                                                   placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB"><span style="padding: 5px;color:red;">*</span>转贷工作日：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="WorkDayNum"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.WorkDayNum"
                                                 oninput="if(isNaN(value)) { value = null }if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                     <el-col :span="3" v-if="loanAudit.DBUserId">
                                        <div class="bankAuditLB">转贷审核人：</div>
                                    </el-col>
                                    <el-col :span="5"  v-if="loanAudit.DBUserId">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.DBName"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3"  v-if="loanAudit.BankFirstUserId">
                                        <div class="bankAuditLB">银行初审：</div>
                                    </el-col>
                                    <el-col :span="5"  v-if="loanAudit.BankFirstUserId">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.BankFirstName"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3"  v-if="loanAudit.BankSecondUserId">
                                        <div class="bankAuditLB">银行复审：</div>
                                    </el-col>
                                    <el-col :span="5"  v-if="loanAudit.BankSecondUserId">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.BankSecondName"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3"  v-if="loanAudit.BankUserId">
                                        <div class="bankAuditLB">银行终审：</div>
                                    </el-col>
                                    <el-col :span="5"  v-if="loanAudit.BankUserId">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.BankThirdName"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                     <el-col :span="3" v-if="loanAudit.ContactFlag">
                                        <div class="bankAuditLB">征信查询说明：</div>
                                    </el-col>
                                    <el-col :span="5" >
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.ContactFlag"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        附件信息
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-bottom: 20px;" v-if="fileList.length>0">
                                    <el-col :span="2"></el-col>
                                    <el-col :span="20">
                                        <div class="bankAuditInfoTable" style="text-align: center;">
                                            <table border="1" bordercolor="#4e717d">
                                                <tr>
                                                    <td class="title" style="width: 15%;">类别</td>
                                                    <td class="title"  style="width: 40%;">文件名称</td>
                                                    <td class="title"  style="width: 15%;">操作</td>
                                                </tr>
                                                <template v-for="item in fileList" :key="item.Id">
                                                <tr>
                                                         <td >{{ FileTypeName[item.FileIndex] }}</td>
                                                         <td ><div style="cursor: pointer;" @click="handleFileView(item.Url)">{{ item.Name }}</div></td>
                                                         <!-- <td >
                                                            <img :src="item.Url" style="float:left;width: 50px;height: 50px;">
                                                            {{ item.Url }}
                                                         </td> -->
                                                         <td ><div style="cursor: pointer;" @click="handleFileView(item.Url)">查看</div></td>
                                                </tr>
                                                </template>
                                            </table>
                                        </div>
                                    </el-col>
                                </el-row>
                            <el-row v-else>
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-scrollbar>
                    </el-tab-pane>
                <el-tab-pane label="信用信息" name="second">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-tabs v-model="activeNameZx" type="card" @tab-click="handleClick">
                               <template v-if="loanAudit.PersonFlag===2">
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            营业执照信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTitle">
                                            <img width="50" height="50" :src="detailResult.ImageUrl"/>
                                            <div class="bankAuditInfoName">{{detailResult.Name}}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row v-if="activeNameZx==='first'">
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table border="1" bordercolor="#4e717d">
                                                <tr>
                                                    <td class="title">登记机关</td>
                                                    <td>{{detailResult.BelongOrg}}</td>
                                                    <td class="title">法定代表人名</td>
                                                    <td style="color:bule ">{{detailResult.OperName}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">成立日期</td>
                                                    <td>{{detailResult.StartDate}}</td>
                                                    <td class="title">企业状态</td>
                                                    <td>{{detailResult.Status}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">注册资本</td>
                                                    <td>{{detailResult.RegistCapi}}</td>
                                                    <td class="title">实缴资本</td>
                                                    <td>{{detailResult.RecCap}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">企业类型</td>
                                                    <td>{{detailResult.EconKind}}</td>
                                                    <td class="title">注册号</td>
                                                    <td>{{detailResult.No}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">地址</td>
                                                    <td colspan="3">{{detailResult.Address}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="title">经营范围</td>
                                                    <td colspan="3">{{detailResult.Scope}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            诉讼信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                        <tr>
                                            <!-- <td class="title">失信被执行数量</td>
                                            <td>{{caseResult[0]}}</td>
                                            <td class="title">被执行数量</td>
                                            <td>{{caseResult[1]}}</td>
                                            <td class="title">严重违法数量</td>
                                            <td>{{caseResult[2]}}</td>
                                            <td class="title">裁判文书数量</td>
                                            <td>{{caseResult[3]}}</td> -->
                                            <td class="title" >失信被执行数量</td>
                        <td v-if="caseResult[0]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(0)">
                          {{caseResult[0]}}</td>
                        <td v-else>0</td>
                        <td class="title">被执行数量</td>
                        <td v-if="caseResult[1]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(1)">
                          {{caseResult[1]}}</td>
                        <td v-else>0</td>
                        <td class="title">严重违法数量</td>
                        <td v-if="caseResult[2]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(2)">
                          {{caseResult[2]}}</td>
                        <td v-else>0</td>
                        <td class="title">裁判文书数量</td>
                        <td v-if="caseResult[3]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(3)">
                          {{caseResult[3]}}</td>
                        <td v-else>0</td>
                                        </tr>
                                    </table>
                                        </div>
                                    </el-col>
                                </el-row>


                                <el-row v-if="dataShow">
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            {{labelList[sxtype]}}信息
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row v-if="dataShow">
                                    <el-col :span="24">
                                        <div class="bankAuditInfoTable">
                                            <table v-if="sxtype==3" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">案由</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:15%">角色</td>
                        <td style="width:15%">案件声明</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.CaseNo}}</td>
                            <td>{{abc.CaseReason}}</td>
                            <td>{{abc.PublishDate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.RoleType}}</td>
                              <td>{{abc.Statement}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==2" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:40%">列入原因</td>
                        <td style="width:30%">列入决定机关</td>
                        <td style="width:15%">列入时间</td>
                        <td style="width:15%">移除时间</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.AddReason}}</td>
                            <td>{{abc.AddOffice}}</td>
                            <td>{{abc.AddDate}}</td>
                            <td>{{abc.RemoveDate}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==1" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">立案时间</td>
                        <td style="width:20%">执行法院</td>
                        <td style="width:20%">执行标的（元）</td>
                        <td style="width:20%">疑似申请执行人</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Liandate}}</td>
                            <td>{{abc.JudgeDate}}</td>
                            <td>{{abc.Biaodi}}</td>
                            <td>{{abc.SuspectedApplicant}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==0" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:15%">履行情况</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:35%">失信行为</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Executestatus}}</td>
                            <td>{{abc.Publicdate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.ActionRemark}}</td>
                        </tr>
                   </table> 
                   <div v-if="mlShow" style=" margin: 10px 40% 4px 40%;width: 20%;">
                     <div @click="getList(-1)"
                     style="cursor: pointer;width:40%;float: left;" >上一页</div>
                     <div style="width:20%;float: left;">{{ pageIndex }}</div> 
                     <div  @click="getList(1)"
                     style="cursor: pointer;width:40%;float: left;">下一页</div>
                   </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="bankAuditSecondLB">
                                            <div class="bankAuditSecondSplit"></div>
                                            农业信息
                                        </div>
                                    </el-col>
                                </el-row>
                        <el-row v-if="llTableData.length==0">
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        <el-row v-else>
                            <el-col :span="24">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="4">权证流水号</td>
                        <td colspan="4">发包方名称</td>
                        <td colspan="4">承包方期限</td>
                        <td colspan="2">承包方名称</td>
                        <td colspan="2">地块面积</td>
                        <td colspan="2">地块总数</td>
                        <td colspan="3">土地类型</td>
                        <td colspan="3">土地用途</td>
                        </tr>
                    <tr v-for="(abc,i) in llTableData">
                            <td colspan="4">{{abc.QZLSH}}</td>
                            <td colspan="4">{{abc.FBFMC}}</td>
                            <td colspan="4">{{abc.CBQXQ}}至{{abc.CBQXZ}}</td>
                            <td colspan="2">{{abc.name}}</td>
                            <td colspan="2">{{abc.area}}</td>
                            <td colspan="2">{{abc.num}}</td>
                            <td colspan="3">{{abc.TDLYLX}}</td>
                            <td colspan="3">{{abc.TDYT}}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                        </el-row>
                          
                        <el-row>
                                    <div style="height:20px"></div>
                                </el-row>
                        </el-tabs>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="身份信息" name="third">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">姓名：{{loanAudit.UserName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">身份证号：{{loanAudit.IdCard}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="2">
                                <div class="viewText">身份证正反面:</div>
                            </el-col>
                        <el-col :span="8">
                                <img style="width: 100%;padding: 5%;" :src="loanAudit.FrontImg"/>
                        </el-col>
                        <el-col :span="2"></el-col>
                        <el-col :span="8">
                                <img style="width: 100%;padding: 5%;" :src="loanAudit.BackImg"/>
                        </el-col>
                        <el-col :span="4"></el-col>

                    </el-row>
                    </el-scrollbar>
                </el-tab-pane>
            </el-tabs>
            
        </div>
    </div>
   
</template>

<script>
import LoanAudit from "./index.js";
import indexJs from "./index.js";
  export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);
    .viewText {
        text-indent: 20px;
        height: 30px;
        line-height: 30px;
        padding: 15px 0px;
        text-align: left;
    }

    .viewRow {
        margin-left: 5%;
        width: 90%;
    }
</style>
